import React from "react";
import { range } from "../../lib/utils";
import { MAX_MISTAKES } from "../../lib/constants";
import { GameStatusContext } from "../../providers/GameStatus";

function MistakeDot({ isUsed }) {
    return (
        <div
            className={`
                w-3 h-3 rounded-full transition-all duration-200
                ${isUsed
                    ? 'bg-gray-200 scale-90'
                    : 'bg-gray-800'
                }
            `}
        />
    );
}

function NumberOfMistakesDisplay() {
    const { numMistakesUsed } = React.useContext(GameStatusContext);
    const mistakeRange = range(MAX_MISTAKES);

    return (
        <div className="flex items-center justify-center gap-3 py-3">
            <span className="text-sm font-medium text-gray-500">
                Mistakes remaining:
            </span>
            <div className="flex gap-1.5">
                {mistakeRange.map((el) => (
                    <MistakeDot key={el} isUsed={el < numMistakesUsed} />
                ))}
            </div>
        </div>
    );
}

export default NumberOfMistakesDisplay;
